import type {
  NotificationIntegrationSpec,
  NotificationIntegrationStruct,
} from '@cohort/shared/schema/apps/app';
import {urlTransformer} from '@cohort/shared/utils/validators';
import {z} from 'zod';

export const CohortCustomRequestNotificationHttpMethodSchema = z.enum([
  'GET',
  'PATCH',
  'PUT',
  'POST',
  'DELETE',
]);
export const CohortCustomRequestNotificationConfigSchema = z.object({
  httpMethod: CohortCustomRequestNotificationHttpMethodSchema,
  url: z
    .string()
    .url()
    .transform(url => urlTransformer(url)),
  body: z
    .string()
    .nullable()
    .transform(body => (!body || body.trim().length === 0 ? null : body.trim())),
  headers: z
    .array(
      z.object({
        key: z.string(),
        value: z.string(),
      })
    )
    .nullable(),
});
export type CohortCustomRequestNotificationConfig = z.infer<
  typeof CohortCustomRequestNotificationConfigSchema
>;

export type CohortCustomRequestNotificationIntegrationStruct = NotificationIntegrationStruct<
  'cohort.custom-request',
  CohortCustomRequestNotificationConfig
>;

export const CohortCustomRequestNotificationIntegrationSpec: NotificationIntegrationSpec<CohortCustomRequestNotificationIntegrationStruct> =
  {
    id: 'cohort.custom-request' as const,
    configSchema: CohortCustomRequestNotificationConfigSchema,
    notificationDataSchema: z.object({}),
    notificationInputSchema: z.object({}),
  };
